import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/footer';
import Header from '../components/header';
// :: Clients | Adber Infra India Pvt. Ltd. ::
const Clients = () => {
    useEffect(() => {
        document.title = ":: Clients | Adber Infra India Pvt. Ltd. ::";
    }, []);
    const clients = [
        { image: 'harikrupa-builders.jpg', alt: 'Harikrupa Builders', title: 'Harikrupa Builders' },
        { image: 'goel-ganga-developers.jpg', alt: 'Goel Ganga Developers', title: 'Goel Ganga Developers' },
        { image: 'Majestique-landmarks.jpg', alt: 'Majestique Landmarks', title: 'Majestique Landmarks' },
        { image: 'dynamic-reality-ventures.jpg', alt: 'Dynamic Reality Ventures', title: 'Dynamic Reality Ventures' },
        { image: 'bharucha-and-motivala.png', alt: 'Bharucha & Motivala Infrastructure Pvt. Ltd.', title: 'Bharucha & Motivala Infrastructure Pvt. Ltd.' },
        { image: 'atrium-homes.jpg', alt: 'Atrium Homes', title: 'Atrium Homes' },
        { image: 'gagan-developers.png', alt: 'Gagan Developers', title: 'Gagan Developers' },
        { image: 'f5-realtors.png', alt: 'F5 Realtors', title: 'F5 Realtors' },
        { image: 'ama-properties.jpg', alt: 'AMA Properties', title: 'AMA Properties' },
        { image: 'vtp-reality.jpg', alt: 'VTP Realty', title: 'VTP Realty' },
        { image: 'atur-india.jpg', alt: 'Atur India', title: 'Atur India' },
        { image: 'golden-palms-infrastructure.png', alt: 'Golden Palm Infrastructure', title: 'Golden Palm Infrastructure' },
        { image: 'marimagnum-construction.jpg', alt: 'Marimagnum Construction', title: 'Marimagnum Construction' },
        { image: 'ranawat-group.png', alt: 'Ranawat Group', title: 'Ranawat Group' },
        { image: 'gagan-properties.jpg', alt: 'Gagan Properties', title: 'Gagan Properties' },
        { image: 'godrej-properties.jpg', alt: 'Godrej Properties', title: 'Godrej Properties' },
        { image: 'ISC-group.jpg', alt: 'ISC', title: 'ISC' },
        { image: 'vascon-engineers.jpg', alt: 'Vascon Engineers', title: 'Vascon Engineers' },
        { image: 'swami-samarth-engineers.jpg', alt: 'Shree Swami Samarth Engineers', title: 'Shree Swami Samarth Engineers' }
    ];

    return (
        <div>
            <Header />
            <section className="inner-page-banner-area news">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8 col-sm-8 col-xs-12">
                            <div className="banner-caption contacttext">
                                <h1 className=""> Clients </h1>
                                <p style={{ color: '#f3f3f3' }}> We listen to our customers </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="breadcrumbs-area">
                <div className="container-fluid">
                    <ol className="breadcrumb">
                        <li><Link to="/" >Home</Link></li>
                        <li>Clients</li>
                    </ol>
                </div>
            </div>

            <div className="container" id="InternalPageArea">
                <div className="row clientsArea">
                    {clients.map((client, index) => (
                        <div key={index} className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                            <div className="clientWrap">
                                <img src={`../assets/images/clients/${client.image}`} alt={client.alt} title={client.title} />
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row">
                    <div className="col-sm-12 col-xs-12 ">
                        <h3> Other Clients </h3>
                    </div>
                    <div className="col-sm-12 col-xs-12 ">
                        <ul className="cleientStyle">
                            <li> Axis Lifespaces LLP </li>
                            <li> Arti Properties Private Limited </li>
                            <li> Dorea Homes LLP </li>
                            <li> Vedant Landmark </li>
                            <li> Sai Khushi Construction </li>
                            <li> Parshuram Construction </li>
                            <li> Wellbuild Merchants Pvt. Ltd. </li>
                            <li> Vihan Construction </li>
                        </ul>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Clients;
